import {
    CREATE_EVENT,
    DESELECT_EVENT,
    GET_ALL_EVENTS,
    SET_USER_HAS_EVENTS_WITH_PRICING,
    GET_EVENT_BY_ID,
    RESET_CREATED_EVENT,
    UPDATE_EVENT,
    DELETE_EVENT,
    RESET_DELETED_EVENT,
    RESET_UPDATED_EVENT,
    ANNOUNCE_EVENT_COMPLETE,
    SET_PUBLIC_GALLERY,
    LOADING_PUBLIC_GALLERY,
    LOADING_EVENT,
    GET_SHARED_WITH,
    GET_EVENT_SHARED_WITH_ME,
    LOADING_SHARED_WITH_ME
} from "./type";
import EventsService from "../../services/eventsService";

export const getAllEvents = () => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_EVENT,
            payload: true
        })
        const response = await EventsService.getAll();

        const atLeastOneEventHasPricingData = response.data.Data.some(event => event.hasOwnProperty('pricingData'));
        dispatch({
            type: GET_ALL_EVENTS,
            payload: response.data
        });

        dispatch({
            type: SET_USER_HAS_EVENTS_WITH_PRICING,
            payload: atLeastOneEventHasPricingData
        });

    } catch (error) {
        console.log(error);
    } finally {
        dispatch({
            type: LOADING_EVENT,
            payload: false
        })
    }
};

export const getEventById = (id) => async (dispatch) => {
    dispatch({
        type: LOADING_EVENT,
        payload: true
    })
    dispatch({
        type: GET_EVENT_BY_ID,
        payload: id
    });
    dispatch({
        type: LOADING_EVENT,
        payload: false
    })
};

export const deselectEvent = () => async (dispatch) => {
    dispatch({
        type: DESELECT_EVENT
    });
};

export const resetCreatedEvent = () => async (dispatch) => {
    dispatch({
        type: RESET_CREATED_EVENT
    });
};

export const createEvent = (event) => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_EVENT,
            payload: true
        })

        const response = await EventsService.createEvent(event);

        dispatch({
            type: CREATE_EVENT,
            payload: response.data
        });
        return response.data.Data || response.data;

    } catch (err) {
        throw err;
    } finally {
        dispatch({
            type: LOADING_EVENT,
            payload: false
        })
    }
};

export const updateEvent = (event) => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_EVENT,
            payload: true
        })

        const response = await EventsService.updateEvent(event);

        dispatch({
            type: UPDATE_EVENT,
            payload: response.data
        });
        return response.data.Data || response.data;

    } catch (err) {
        throw err;
    } finally {
        dispatch({
            type: LOADING_EVENT,
            payload: false
        })
    }
};

export const announceEventComplete = (id) => async (dispatch) => {
    const response = await EventsService.announceComplete(id);

    dispatch({
        type: ANNOUNCE_EVENT_COMPLETE,
        payload: { id, ...response.data }
    });

    return response.data;
};

// Enciende o apaga la galería pública. No pasa por LOADING_EVENT: ese flag desmonta el
// cuerpo de la pestaña (eventContainer) y el interruptor perdería el foco al conmutar.
export const setPublicGallery = (id, active) => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_PUBLIC_GALLERY,
            payload: true
        })

        const response = await EventsService.setPublicGallery(id, active);
        const data = response.data?.Data || response.data || {};

        dispatch({
            type: SET_PUBLIC_GALLERY,
            payload: { id, publicGalleryActive: data.publicGalleryActive ?? active, publicPosterWarning: data.publicPosterWarning }
        });
        return data;

    } finally {
        dispatch({
            type: LOADING_PUBLIC_GALLERY,
            payload: false
        })
    }
};

export const getEventSharedWithMe = () => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_SHARED_WITH_ME,
            payload: true
        })

        const response = await EventsService.getEventSharedWithMe();
        dispatch({
            type: GET_EVENT_SHARED_WITH_ME,
            payload: response.data
        });

    } catch (err) {
        console.log(err);
    } finally {
        dispatch({
            type: LOADING_SHARED_WITH_ME,
            payload: false
        })
    }
}

export const getEventSharedWith = (id) => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_EVENT,
            payload: true
        })

        const response = await EventsService.getSharedWith(id);

        dispatch({
            type: GET_SHARED_WITH,
            payload: response.data
        });


    } catch (err) {
        console.log(err);
    } finally {
        dispatch({
            type: LOADING_EVENT,
            payload: false
        })
    }
}

export const editEventSharedWith = (id, sharedWith) => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_EVENT,
            payload: true
        })

        await EventsService.editSharedWith(id, sharedWith);

        dispatch({
            type: GET_SHARED_WITH,
            payload: sharedWith
        });

    } catch (err) {
        console.log(err);
    } finally {
        dispatch({
            type: LOADING_EVENT,
            payload: false
        })
    }
}

export const deleteEvent = (id) => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_EVENT,
            payload: true
        })

        await EventsService.deleteEvent(id);

        dispatch({
            type: DELETE_EVENT,
            payload: id
        });

    } catch (err) {
        console.log(err);
    } finally {
        dispatch({
            type: LOADING_EVENT,
            payload: false
        })
    }
};

export const resetDeletedEvent = () => async (dispatch) => {
    dispatch({
        type: RESET_DELETED_EVENT
    });
};

export const resetUpdatedEvent = () => async (dispatch) => {
    dispatch({
        type: RESET_UPDATED_EVENT
    });
};
